import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NcIconService } from '@neurocare/ui';
import { ILoggingService } from '@neurocare/utils';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterOutlet],
})
export class AppComponent {
  readonly loggingService = inject(ILoggingService);
  readonly iconService = inject(NcIconService);

  title = 'patient';
  constructor() {
    const iconService = this.iconService;

    iconService.registerAllIcons('assets/icons');
  }
}
